import React, { useContext, useEffect } from "react";
import useGlobalContext from "../../../hooks/useGlobalContext.js";
import { FLOATING_PANEL_MARGIN, STICKY_FOOTER_SPACER_ID } from "../../../constants.js";
import { RemoteFooter } from "../../remote/index.js";
import scrollToTop from "../../../utils/scrollToTop.js";
import Frame from "../Frame/index.js";
import styles from "./AppShell.module.css";
import { OutletContext } from "./Outlet/index.js";
const AppShell = (props) => {
    const { noPadding = false, header, children, noMainWrapper } = props;
    const { ipCountry } = useGlobalContext();
    const isUK = ipCountry?.toLowerCase() === "gb";
    const { sheetContainer } = useContext(OutletContext);
    useEffect(scrollToTop, []);
    const content = React.createElement(Frame, { className: styles.appShell }, children);
    return (React.createElement("div", { id: "app-shell", className: styles.root, style: { paddingBottom: noPadding && !isUK ? undefined : FLOATING_PANEL_MARGIN } },
        !!header && React.createElement("div", { id: "app-header" }, header),
        noMainWrapper ? (content) : (React.createElement("main", { id: "basiclayout", role: "main" }, content)),
        React.createElement("div", { id: STICKY_FOOTER_SPACER_ID, "aria-hidden": true }),
        React.createElement(RemoteFooter, null),
        sheetContainer));
};
export default AppShell;
